import AppButton from '@nxsys/components/AppButton';
import AppDescription from '@nxsys/components/AppDescription';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Icons } from '@nxsys/types/icons';
import { ICompany } from '@nxsys/types/models/company';
import { Descriptions } from 'antd';

type Props = {
  data?: ICompany;
  onEdit?: () => void;
};

const ContactAndPayment: React.FC<Props> = ({ data, onEdit }) => {
  const { messages } = useTypedIntl();

  return (
    <div className="ContactAndPayment">
      {onEdit && (
        <div className="flex justify-end mb-[16px]">
          <AppButton
            variant="outlined"
            leftIcon={<Icons.IconEdit />}
            name={messages['common.edit']}
            onClick={onEdit}
          />
        </div>
      )}
      <AppDescription
        column={2}
        labelStyle={{ width: 216 }}
        bordered={false}
        colon={false}
        size="middle"
      >
        <Descriptions.Item label={messages['common.address1']}>
          {data?.pensionSetting?.address[0] || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={messages['common.address2']}>
          {data?.pensionSetting?.address[1] || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={messages['common.address3']}>
          {data?.pensionSetting?.address[2] || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={messages['common.address4']}>
          {data?.pensionSetting?.address[3] || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={messages['common.eircode']}>
          {data?.pensionSetting?.eirCode || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={messages['common.phone']}>
          {data?.pensionSetting?.phone || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={messages['common.bankName']}>
          {data?.pensionSetting?.bankName || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={messages['common.bankBranch']}>
          {data?.pensionSetting?.bankBranch || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={messages['common.bankSortCode']}>
          {data?.pensionSetting?.bankSortCode || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={messages['common.accountNumber']}>
          {data?.pensionSetting?.bankAccountNumber || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={messages['common.bankAccountName']}>
          {data?.pensionSetting?.bankAccountName || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={messages['common.bankReference']}>
          {data?.pensionSetting?.bankReference || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={messages['common.iban']}>
          {data?.pensionSetting?.IBAN || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={messages['common.bic']}>
          {data?.pensionSetting?.BIC || '-'}
        </Descriptions.Item>
      </AppDescription>
    </div>
  );
};

export default ContactAndPayment;
